import { render, staticRenderFns } from "./TheStepperBottom.vue?vue&type=template&id=60a9328a&lang=pug&"
import script from "./TheStepperBottom.vue?vue&type=script&lang=js&"
export * from "./TheStepperBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports